<template>
  <div class="unit-items">
    <div class="unit-title">
      <div class="unit-light" :class="color">
        <div class="unit-light-inner">
          <div>
            <p>{{ above }}</p>
            <h2>{{ title }}</h2>
            <p>{{ below }}</p>
          </div>
        </div>
      </div>
    </div>
    <p>Fill in the boxes below</p>
    <v-card light class="mb-5 mt-0 field">
      <v-card-text>
        <p class="mb-2 overline black--text">1 {{name}}</p>
        <v-textarea
          :color="color"
          v-model="items[0].title"
          :rows="2"
          :autoGrow="true"
          :hide-details="true"
          class="field"
        />
      </v-card-text>
    </v-card>
    
    <v-card light class="mb-5 field">
      <v-card-text>
        <p class="mb-2 overline black--text">2 {{name}}</p>
        <v-textarea
          :color="color"
          v-model="items[1].title"
          :rows="2"
          :autoGrow="true"
          :hide-details="true"
          class="field"
        /> </v-card-text
    ></v-card>
    
    <v-card light class="mb-10 field">
      <v-card-text>
        <p class="mb-2 overline black--text">3 {{name}}</p>
        <v-textarea
          :color="color"
          v-model="items[2].title"
          :rows="2"
          :autoGrow="true"
          class=""
          :hide-details="true"/></v-card-text
    ></v-card>

    <!-- <draggable
      class="inner mt-5"
      :list="items"
      group="order"
      @start="startDrag()"
      @end="endDrag()"
      :ref="name"
      :id="name"
    >
      <div
        v-for="(item, index) in items"
        :key="`unit-${index}`"
        class="item"
        :data-id="`${Math.round(new Date().getTime() / 1000)}`"
        :class="{ hidden: checkEditIndex(index) }"
      >
        <v-textarea
          :color="color"
          v-model="item.title"
          :rows="1"
          :autoGrow="true"
          v-if="editMode"
          :hide-details="true"
        />
        <p v-else>{{ item.title }}</p>
        <div class="icons">
          <v-icon
            @click="edit(index)"
            v-if="editMode && editIndex == index"
            class="white--text ma-1"
            >mdi-check-circle</v-icon
          >
          <v-icon @click="edit(index)" v-else class="white--text ma-1"
            >mdi-pencil</v-icon
          >
          <v-icon @click="remove(index)" class="white--text ma-1"
            >mdi-delete-forever</v-icon
          >
        </div>
      </div>
    </draggable> -->
  </div>
</template>

<script>
// @ is an alias to /src
// import draggable from "vuedraggable";
export default {
  name: "OrderedItems",
  data() {
    return {
      items: this.value,
      item: {},
      currIndex: null,
      refs: null,
      fields: [],
      editMode: false,
      editIndex: "",
    };
  },
  props: {
    value: Array,
    name: String,
    title: String,
    above: String,
    below: String,
    color: String,
    limit: Number,
  },
  components: {
    // draggable,
  },
  watch: {
    value: {
      handler: function(val) {
        this.items = val;
      },
      deep: true,
    },
  },
  computed: {
    maxItems() {
      if (this.limit) {
        return (this.items && this.items.length) >= this.limit ? true : false;
      } else {
        return false;
      }
    },
  },
  mounted() {
    if (this.collection) {
      this.getRefs();
    }
  },
  methods: {
    add() {
      let item = {
        index: this.items.length,
        title: this.item.title,
        id: this.items.length,
        type: "content",
      };
      this.items.push(item);
      this.item = {};

      this.editMode = false;
      this.currId = null;
      this.currIndex = null;
    },
    remove(index) {
      this.items.splice(index, 1);
    },
    edit(index) {
      this.editMode = !this.editMode;
      this.editIndex = index;
    },
    startDrag() {
      this.dragging = true;
    },
    endDrag() {
      let count = 0;
      let vm = this;
      let div = document.getElementById(this.name);
      div.children.forEach((doc) => {
        let item = this.items.find((x) => x.id == doc.dataset.id);
        console.log(item);
        let indexOfItem = this.items.indexOf(item);
        item.index = count;
        vm.$set(vm.items, indexOfItem, item);
        count++;
      });
      this.dragging = false;
    },
    checkEditIndex(index) {
      if (this.editMode) {
        return index == this.editIndex ? false : true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.unit-items {
  .item {
    padding: 0.5rem;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin: 0.5rem 0;
    background: #222222;
    border-radius: 10px;
    color: white;
    font-size: 1.1rem;
    line-height: 1.3rem;
    font-weight: 400;
    .icons {
      width: 50px;
      padding: 0 10px;
      display: flex;
    }
  }
}
.field {
  textarea {
    background: rgb(235, 235, 235) !important;
    padding: .5rem !important;
    height: auto !important;
  }
}
.hidden {
  opacity: 0;
}
.add-button {
  margin: 0 !important;
  position: relative;
  right: 0;
}
.unit-field {
  margin: 0.75rem 0 !important;
}
.unit-light {
  width: 250px;
  height: 250px;
  @media (min-width: 980px) {
    width: 300px;
    height: 300px;
  }
  @media (min-width: 1200px) {
    width: 400px;
    height: 400px;
  }
  // padding-bottom: 100%;
  border-radius: 50%;
  margin: 0.5rem auto;
  background: white;
  position: relative;

  .unit-light-inner {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    position: absolute;
    top: 0;
    left: 50%;
    width: 80%;
    height: 100%;
    transform: translateX(-50%);
  }
  p {
    color: white;
    font-weight: 600;
    margin: 0;
    font-size: 1rem;
      line-height: 1.2rem;
    @media (min-width: 980px) {
      font-size: 1.2rem;
      line-height: 1.4rem;
    }
    @media (min-width: 1200px) {
      font-size: 1.4rem;
      line-height: 1.8rem;
    }
    text-transform: uppercase;
  }
  h2 {
    text-transform: uppercase;
    color: white;
    font-size: 3rem;
    line-height: 3rem;
      @media (min-width: 980px) {
    font-size: 4rem;
    line-height:4rem;
  }
  @media (min-width: 1200px) {
     font-size: 5rem;
    line-height: 5rem;
  }
  }
}

</style>
